import App from './App';
import './App.css';

export default App;



// WEBPACK FOOTER //
// ./src/components/app/index.ts